import { buildURL, fetchJSON, fetchPaginatedJSON, fetchWithAuth, paginateQueryParams } from "../util/fetch-utils";
//Pass this value to ModifySpecificAssetParams.device_id to unpair the asset
export const MODIFY_SPECIFIC_ASSET_UNPAIR_DEVICE_ID = "None";
export default class VelavuAPIAssets {
    //This endpoint retrieves all assets.
    //https://docs.velavu.com/#get-all-assets
    getAllAssets(params, pagination) {
        const query = {};
        if (params?.include_profile_images !== undefined) {
            query["include_profile_images"] = String(params.include_profile_images);
        }
        if (params?.paired !== undefined) {
            query["paired"] = String(params.paired);
        }
        if (params?.online !== undefined) {
            query["online"] = String(params.online);
        }
        if (params?.only_registered !== undefined) {
            query["only_registered"] = String(params.only_registered);
        }
        if (params?.category !== undefined) {
            query["category"] = params.category;
        }
        if (params?.group !== undefined) {
            query["group"] = params.group;
        }
        if (params?.name !== undefined) {
            query["name"] = params.name;
        }
        const url = buildURL("/assets", paginateQueryParams(pagination, query));
        return fetchPaginatedJSON(url);
    }
    //This creates a new Asset object.
    //https://docs.velavu.com/#create-a-new-asset
    createNewAsset(params) {
        return fetchJSON("/assets", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(params),
        });
    }
    //This request returns the entire data of a requested asset.
    //https://docs.velavu.com/#get-a-specific-asset
    getSpecificAsset(assetID) {
        return fetchJSON(`/assets/${assetID}`);
    }
    //This endpoint modifies one or more properties of the asset.
    //https://docs.velavu.com/#modify-a-specific-asset
    modifySpecificAsset(assetID, params) {
        return fetchJSON(`/assets/${assetID}`, {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(params),
        });
    }
    //This method deletes a specific asset.
    //https://docs.velavu.com/#delete-a-specific-asset
    deleteSpecificAsset(assetID) {
        return fetchWithAuth(`/assets/${assetID}`, { method: "DELETE" });
    }
    //This method uploads a profile picture for an asset.
    //https://docs.velavu.com/#upload-a-profile-picture-for-an-asset
    uploadProfilePicture(assetID, dataBase64) {
        return fetchJSON(`/assets/${assetID}/profile_img`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ image: dataBase64 }),
        });
    }
    //This method deletes an asset's profile image.
    //https://docs.velavu.com/#delete-a-profile-picture-for-an-asset
    deleteProfilePicture(assetID) {
        return fetchWithAuth(`/assets/${assetID}/profile_img`, { method: "DELETE" });
    }
}
//# sourceMappingURL=velavu-api-assets.js.map